<template>
  <v-container grid-list-md text-xs-center full-width>
    <v-content>
      <v-layout>
        <v-flex xs12>
          <v-alert :value="true" type="error">{{mensagem}}</v-alert>
        </v-flex>
      </v-layout>
    </v-content>
  </v-container>
</template>

<script>
  import alerts from "../common/alerts";

  export default {
    props: {
      erro: {
        type: [String, Error],
        default: 'Ocorreu um erro.'
      }
    },
    computed: {
      mensagem() {
        return alerts.extrairMensagemErro(this.erro);
      }
    }
  }
</script>
